<!-- Administration -->
<mdb-accordion-item>
  <mdb-accordion-item-head mdbWavesEffect>
    <jhi-bary-icon icon="user-plus" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
    <span class="h6" jhiTranslate="SIDEBAR.ADMIN.TITLE">Administration</span>
  </mdb-accordion-item-head>
  <mdb-accordion-item-body [customClass]="'overflow-auto'">
    <ul>
      <li>
        <a [routerLink]="PATHS.ADMIN_TOOLS.path" data-id-cypress="sidebar-admin-tools" routerLinkActive="active-link" jhiTranslate="SIDEBAR.ADMIN.TOOLS" mdbWavesEffect> Tools </a>
      </li>
      <li>
        <a
          data-id-cypress="sidebar-client"
          [routerLink]="PATHS.ADMIN_USER_MANAGEMENT.path"
          routerLinkActive="active-link"
          jhiTranslate="SIDEBAR.ADMIN.USERMANAGEMENT"
          mdbWavesEffect
        >
          User management
        </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_MODERATOR_MANAGEMENT.path" routerLinkActive="active-link" jhiTranslate="SIDEBAR.ADMIN.MODERATORMANAGEMENT" mdbWavesEffect>
          Moderator management
        </a>
      </li>
      <li>
        <a
          [routerLink]="PATHS.ADMIN_IMPERSONATE_MANAGEMENT.path"
          routerLinkActive="active-link"
          data-id-cypress="sidebar-impersonate"
          jhiTranslate="SIDEBAR.ADMIN.IMPERSONATEMANAGEMENT"
          mdbWavesEffect
        >
          Impersonate management
        </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_METRICS.path" routerLinkActive="active-link" jhiTranslate="SIDEBAR.ADMIN.METRICS" mdbWavesEffect> Metrics </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_HEALTH.path" routerLinkActive="active-link" jhiTranslate="SIDEBAR.ADMIN.HEALTH" mdbWavesEffect> Health </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_CONFIGURATION.path" routerLinkActive="active-link" jhiTranslate="SIDEBAR.ADMIN.CONFIGURATION" mdbWavesEffect> Configuration </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_LOGS.path" routerLinkActive="active-link" jhiTranslate="SIDEBAR.ADMIN.LOGS" mdbWavesEffect> Logs </a>
      </li>
      <li *ngIf="swaggerEnabled">
        <a [routerLink]="PATHS.ADMIN_DOCS.path" routerLinkActive="active-link" jhiTranslate="SIDEBAR.ADMIN.API" mdbWavesEffect> API </a>
      </li>
    </ul>
  </mdb-accordion-item-body>
</mdb-accordion-item>

<!-- Transporteurs -->
<mdb-accordion-item>
  <mdb-accordion-item-head mdbWavesEffect>
    <jhi-bary-icon icon="truck" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
    <span class="h6" jhiTranslate="SIDEBAR.TRANSPORTER.TITLE">Transporters</span>
  </mdb-accordion-item-head>
  <mdb-accordion-item-body [customClass]="'overflow-auto'">
    <ul>
      <li>
        <a [routerLink]="PATHS.ADMIN_TRANSPORTER_MANAGEMENT_DASHBOARD.path" routerLinkActive="active-link" jhiTranslate="SIDEBAR.TRANSPORTER.DASHBOARD" mdbWavesEffect>
          Dashboard
        </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_NEW_SHOP.path" routerLinkActive="active-link" jhiTranslate="SIDEBAR.TRANSPORTER.CREATENEWSHOP" mdbWavesEffect> Create a Transporter </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_TRANSPORTER_MANAGEMENT_IMPORT.path" routerLinkActive="active-link" jhiTranslate="SIDEBAR.TRANSPORTER.IMPORTTRANSPORTER" mdbWavesEffect>
          Import a Transporter
        </a>
      </li>
      <li *ngFor="let transporterOption of transporters; trackBy: trackById">
        <a routerLinkActive="active-link" [routerLink]="PATHS.ADMIN_TRANSPORTER_MANAGEMENT_ID_EDIT.path.replace(':id', transporterOption!.id!.toString())" mdbWavesEffect>
          {{ transporterOption.technicalName }}
        </a>
      </li>
    </ul>
  </mdb-accordion-item-body>
</mdb-accordion-item>
